export default __webpack_public_path__ + "static/media/Niramit-Light.4b84fe45.ttf";